import type { ExportStringOptions } from "cytoscape";

import { $cytoscapeInstance } from "../../stores/graph/ui.ts";

interface ExportResult {
  base64Uri: string;
  downloadLink?: HTMLAnchorElement;
}

export const exportGraphAsPng = async (): Promise<ExportResult | null> => {
  const cytoscapeInstance = $cytoscapeInstance.get();

  if (!cytoscapeInstance) {
    console.error("Cytoscape instance not found");
    return null;
  }

  try {
    // Wait for any pending animations
    await new Promise((resolve) => setTimeout(resolve, 100));

    // Get elements and zoom to fit
    const elements = cytoscapeInstance.elements();
    if (!elements) {
      console.error("No elements found in graph");
      return null;
    }

    // Zoom to fit with padding
    cytoscapeInstance.animate({
      duration: 100,
      fit: {
        eles: elements,
        padding: 20,
      },
    });

    // Wait for zoom animation to complete
    await new Promise((resolve) => setTimeout(resolve, 150));

    // Generate PNG with correct ExportStringOptions
    const base64Uri = cytoscapeInstance.png({
      bg: "#1B1B1D",
      full: true,
      output: "base64",
      scale: 2,
    } as ExportStringOptions);

    // Create and trigger download
    const downloadLink = document.createElement("a");
    downloadLink.href = `data:image/png;base64,${base64Uri}`;
    downloadLink.download = "graph.png";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    return {
      base64Uri,
      downloadLink,
    };
  } catch (error) {
    console.error("Error exporting graph:", error);
    return null;
  }
};
